<template>
  <div class="payment">
    <div class="payment__title-box">
      <h3 class="payment__title">Payment Information</h3>
      <a class="payment__edit payment-edit-btn" @click="editCard">Edit</a>
      <CardEditPopup ref="popupCardEdit" :billing="billing" />
    </div>
    <div v-if="billing.card_data?.last4" class="payment-card">
      <p class="payment-card-num">
        <span class="payment-card__unit">
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i
        ></span>
        <span class="payment-card__unit">
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i
        ></span>
        <span class="payment-card__unit">
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i>
          <i class="payment-card__unit-dot"></i
        ></span>
        <span class="payment-card__unit">
          {{ billing.card_data.last4 }}
        </span>
      </p>
      <div class="payment-card__date">
        <p class="payment-card__text">
          <span class="payment-card__brand payment-card__text--black-text">
            {{ billing.card_data.brand }}
          </span>
          - Expires
          <span class="payment-card__expiration payment-card__text--black-text">
            {{ billing.card_data.exp_month }}/{{ billing.card_data.exp_year }}
          </span>
        </p>
        <div class="payment-card__icon">
          <img
            v-if="billing.card_data?.brand === 'Visa'"
            class="card-details__icon"
            src="@/assets.app/images/card-details-visa.svg"
            alt=""
          />
          <img
            v-else
            class="card-details__icon"
            src="@/assets.app/images/card-details.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      v-else-if="billing.stripe_payment_type"
      class="payment-card payment-card--no-card"
    >
      <p class="payment-card__no-card">
        You paid with <strong>{{ payment_type_text() }}</strong
        >.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { BillingView } from '@/models/billing'

import CardEditPopup from './CardEditPopup.vue'

const props = defineProps<{
  billing: BillingView
}>()

const popupCardEdit = ref<InstanceType<typeof CardEditPopup> | null>(null)

function payment_type_text(): string {
  switch (props.billing.stripe_payment_type) {
    case 'link':
      return 'Stripe Link'
    case 'cashapp':
      return 'Cash App Pay'
    case 'amazon_pay':
      return 'Amazon Pay'
  }
  return 'an alternative payment method'
}

function editCard(): void {
  if (!popupCardEdit.value) {
    return
  }

  popupCardEdit.value.show()
}
</script>
